{
  "fr": {
    "lot": {
      "attributes": {
        "end_date": "Date d'achèvement",
        "internal_note": "Note interne",
        "land_register": "Cadastre",
        "name": "Nom",
        "start_date": "Date de début",
        "surface": "Surface"
      },
      "labels": {
        "lot": "Pas de lot | Un lot | {count} Lots"
      },
      "toasts": {
        "create": "Lot créé",
        "delete": "Lot supprimé",
        "update": "Lot modifié"
      },
      "validation": {
        "needName": "Titre est requis",
        "needNumber": "Doit être un nombre (par exemple 85.5)"
      }
    }
  }
}
